import { FC } from "react"
import './energia.css'
import { EnergiaTable } from "./EnergiaTable/EnergiaTable"
import { EnergiaTableSimple } from "./EnergiaTable/EnergiaTableSimple"

export const Energia:FC<any> = (props):JSX.Element => {
    const { data, setData, dataMASTER, simulated, original, comparativa, saveLoading, same, scenarioBase } = props

    return (
        <div className="energia__wrapper">
            {
                comparativa?
                    <EnergiaTable
                        scenarioBase={scenarioBase}
                        data={data}
                        setData={setData}
                        dataMASTER={dataMASTER}
                        simulated={simulated}
                        original={original}
                        saveLoading={saveLoading}
                        same={same}
                        />
                :
                    <EnergiaTableSimple
                        scenarioBase={scenarioBase}
                        data={data}
                        setData={setData}
                        dataMASTER={dataMASTER}
                        simulated={simulated}
                        original={original}
                        saveLoading={saveLoading}
                    />
            }
            
        </div>
    )
}